export const radius = {
  site: 200, //meters
  user: 200, //meters
}

export const maxScannedInDistance = 200
